<nz-modal
  *ngIf="isVisible"
  [(nzVisible)]="isVisible"
  [nzStyle]="{ top: '50px' }"
  [nzTitle]="task?.processTitle"
  (nzOnCancel)="close()"
  [nzMaskClosable]="false"
  [nzWidth]="1450"
>
  <ng-container *nzModalContent>
    <div class="full-panel equal-height" style="margin-left: 0; padding-bottom: 60px">
      <nz-card class="container" style="width: 76%; margin-right: 10px">
        <nz-card-tab>
          <nz-tabset *ngIf="forms" [(nzSelectedIndex)]="index" (nzSelectedIndexChange)="changeIndex($event)">
            <nz-tab *ngFor="let t of forms" [nzTitle]="t.displayName"></nz-tab>
          </nz-tabset>
        </nz-card-tab>
        <div [style.display]="isFormVisible" [ngClass]="auditShow ? 'apply-info-content-deal' : 'apply-info-content-deal-init'">
          <nb-form-viewer
            [formGroup]="currentGroup"
            [form]="currentForm"
            [data]="currentData"
            [readonly]="true"
            [downloadUrl]="downloadUrl"
            [importUrl]="importUrl"
            [uploadUrl]="uploadUrl"
            [token]="token"
            [pdfUrl]="pdfUrl"
          ></nb-form-viewer>
        </div>

        <div>
          <div *ngIf="auditShow" style="display: flex; justify-content: space-between">
            <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="审核意见" style="position: relative; width: 50%">
              <div class="is-require" *ngIf="submitAction?.reasonRequired">*</div>
              <textarea
                style="width: 100%"
                nz-input
                placeholder="请输入意见"
                [(ngModel)]="comment"
                [nzAutosize]="{ minRows: 5, maxRows: 5 }"
              ></textarea>
            </nz-card>
            <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="审核签名" style="position: relative; width: 50%">
              <div class="is-require" *ngIf="submitAction?.signRequired">*</div>
              <nb-signature [token]="token" [downloadUrl]="downloadUrl" [uploadUrl]="uploadUrl" [(ngModel)]="sign"></nb-signature>
            </nz-card>
          </div>

          <!--          <div style="display: flex; justify-content: space-around; align-items: stretch; padding: 20px 18% 10px 18%; position: relative">-->
          <!--            <div style="position: absolute; right: 10px; top: 10px">-->
          <!--              <div *ngIf="!auditShow" class="flow-up-down-box" (click)="auditShow = true">-->
          <!--                <img class="shrink-img" src="../../../../assets/img/flow-up.svg" alt="" />展开-->
          <!--              </div>-->
          <!--              <div *ngIf="auditShow" class="flow-up-down-box" (click)="auditShow = false">-->
          <!--                <img class="shrink-img" src="../../../../assets/img/flow-down.svg" alt="" />收起-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div *ngFor="let op of operations" nz-popconfirm [nzPopconfirmTitle]="op.tip" (nzOnConfirm)="submitTask(op)">-->
          <!--              <button style="min-width: 28%" nz-button [nzType]="op.type" [nzLoading]="op.loading">-->
          <!--                {{ op.name }}-->
          <!--              </button>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </nz-card>

      <div class="left-panel" style="width: 26%">
        <h1 class="title">{{ ticket.nodeName }}</h1>
        <nz-card *ngIf="meta" nzBorderless nzSize="small" class="indicator-card" [nzTitle]="meta.displayName">
          <div class="applicant">
            <sv-container [col]="1">
              <ng-container *ngIf="meta && meta.fields">
                <sv *ngFor="let mt of meta.fields" [label]="mt.title">{{ explainMeta(mt) }}</sv>
              </ng-container>
            </sv-container>
          </div>
          <div class="nb-divider"></div>
        </nz-card>

        <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="抄送信息">
          <div class="make-copy-frame">
            <div class="copy-each" *ngFor="let op of task?.ccUsers">
              <div class="copy-img-box">
                <div class="bg-img">
                  <img
                    class="copy-img"
                    [src]="userMap[op] && userMap[op].avatar ? downLoad + userMap[op].avatar : '../../../../assets/picture/init-img.png'"
                  />
                </div>
              </div>
              <div>{{ userMap[op] ? userMap[op].name : '-' }}</div>
            </div>
          </div>
          <div class="nb-divider"></div>
        </nz-card>

        <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="审核信息">
          <div class="applicant">
            <sv-container [col]="1">
              <sv label="审核人">{{ auditInfo?.operateName }}</sv>
              <sv label="审核时间">{{ auditInfo?.date }}</sv>
              <sv label="审核操作">{{ auditInfo?.routeName }}</sv>
              <sv label="审核意见">{{ auditInfo?.comment }}</sv>
              <sv class="sign" *ngIf="auditInfo.singImg" label="审核签字"><img class="sign-img" [src]="auditInfo.singImg" alt="icon" /></sv>
            </sv-container>
          </div>
        </nz-card>
      </div>
    </div>
  </ng-container>
  <div *nzModalFooter></div>
</nz-modal>
